import { render, staticRenderFns } from "./SystemFunctionEdit.vue?vue&type=template&id=3cf501d4&"
import script from "./SystemFunctionEdit.vue?vue&type=script&lang=js&"
export * from "./SystemFunctionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports